
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ClientproxyApiClient } from "../clients/ClientproxyApiClient";
import { IMeasuresResult } from "./models/IMeasuresResult";
import { IGetMeasuresParameters } from "./models/IGetMeasuresParameters";
import { INeuralNetworkPredictionResult } from "./models/INeuralNetworkPredictionResult";
import { IGetNeuralNetworkPredictionParameters } from "./models/IGetNeuralNetworkPredictionParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class MeasureListService
{
	private readonly url: string;

	constructor(private readonly apiClient: ClientproxyApiClient)
    {
        this.url = "measurelist";
    }

    async getAggregations(parameters: IGetMeasuresParameters): Promise<IMeasuresResult[]>
    {
        return await this.apiClient.post<IMeasuresResult[]>(`${this.url}/aggregations`,{},JSON.stringify(parameters));
    }

    async getNeuralNetworkPrediction(parameters: IGetNeuralNetworkPredictionParameters): Promise<INeuralNetworkPredictionResult>
    {
        return await this.apiClient.post<INeuralNetworkPredictionResult>(`${this.url}/prediction`,{},JSON.stringify(parameters));
    }
}
